import { Signal } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

export function getDmCostObjectFields(
    disabled: boolean,
    translocoContent: Signal<any>
): FormlyFieldConfig[] {
    const prefix = 'systemTables.dmCostObject.';
    return [
        {
            className: 'flex-1',
            type: 'input',
            key: 'controllingArea',
            props: {
                label: translocoContent()[prefix + 'controllingArea'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costObject',
            props: {
                label: translocoContent()[prefix + 'costObject'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'type',
            props: {
                label: translocoContent()[prefix + 'type'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'name',
            props: {
                label: translocoContent()[prefix + 'name'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1 hidden',
            type: 'input',
            key: 'description',
            props: {
                label: translocoContent()[prefix + 'description'],
                required: false,
                disabled: disabled,
            },
            defaultValue: '',
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'responsible',
            props: {
                label: translocoContent()[prefix + 'responsible'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'category',
            props: {
                label: translocoContent()[prefix + 'category'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'hierarchy',
            props: {
                label: translocoContent()[prefix + 'hierarchy'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'plant',
            props: {
                label: translocoContent()[prefix + 'plant'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'functionalArea',
            props: {
                label: translocoContent()[prefix + 'functionalArea'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'currency',
            props: {
                label: translocoContent()[prefix + 'currency'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'profitCenter',
            props: {
                label: translocoContent()[prefix + 'profitCenter'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1 hidden',
            type: 'input',
            key: 'metadata',
            props: {
                label: translocoContent()[prefix + 'metadata'],
                required: false,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costObjectGroup',
            props: {
                label: translocoContent()[prefix + 'costObjectGroup'],
                required: true,
                disabled: disabled,
            },
        },
        {
            className: 'flex-1',
            type: 'input',
            key: 'costObjectGroupText',
            props: {
                label: translocoContent()[prefix + 'costObjectGroupText'],
                required: true,
                disabled: disabled,
            },
        },
    ];
}
